import React from 'react';
import PropTypes from 'prop-types';

const Setting = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <path fill="none" d="M0,0h24v24H0V0z" />
      <g>
        <path fill={color} d="M9.1,9.1c-1.3,0-2.3,0.8-2.7,1.9H3.4V13h3.1c0.4,1.1,1.5,1.9,2.7,1.9s2.3-0.8,2.7-1.9h8.8V11h-8.8
                C11.4,9.9,10.4,9.1,9.1,9.1z M9.1,13c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C10.1,12.5,9.7,13,9.1,13z"/>
        <path fill={color} d="M15.8,15.7c-1.3,0-2.3,0.8-2.7,1.9H3.4v1.9h9.8c0.4,1.1,1.5,1.9,2.7,1.9c1.3,0,2.3-0.8,2.7-1.9h2.1v-1.9h-2.1
                C18.1,16.5,17.1,15.7,15.8,15.7z M15.8,19.6c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C16.8,19.2,16.4,19.6,15.8,19.6z"/>
        <path fill={color} d="M18.5,4.4c-0.4-1.1-1.5-1.9-2.7-1.9c-1.3,0-2.3,0.8-2.7,1.9H3.4v1.9h9.8c0.4,1.1,1.5,1.9,2.7,1.9c1.3,0,2.3-0.8,2.7-1.9
                h2.1V4.4H18.5z M15.8,6.3c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C16.8,5.9,16.4,6.3,15.8,6.3z"/>
      </g>
    </svg>
  );
}

Setting.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Setting.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Setting;



// WEBPACK FOOTER //
// ./src/components/Icons/Setting.jsx